$(document).ready(function() {
	$.ajaxSetup({
		headers: {
			"X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
		},
	});

	initHomeBanner();
	initInnerBanner();
  initHomepageSecondContentSlide();
	initMobileMenu();
	initAdsSlider();
  initOpenAndCloseMainSidebarMenu();
  initPageMilestone();
  initInnerPageNavigationSlide();

	imgToBG($(".bg-img"), ".img-bg");

	// stickyHeader();
  // stickyFooter();

	$(".venobox").venobox({
		titlePosition: "bottom",
	});

  window.captchaCallback = function(response) {
    $(".g-recaptcha").val(response);
  };

	initNewsletterListener();
	initContactFormListener();

	reSizeCaptcha();

	AOS.init();

  /* from template */

  var wWidth =  window.innerWidth ? window.innerWidth : jQuery(window).width();
  var menu_array = [];
  for(i=0; i< $('#menu_wrap #dropmenu > li').length; i++) {
      menu_array[i] = 0; //0은 닫힌상태, 1은 열린상태
  }

  $('.1depth_btn').on('click',function (){
      $(this).toggleClass('active');
      $(this).siblings('ul').stop().slideToggle();
      if($(this).hasClass('active')){
          $(this).children('span').text('닫기');
      }else{
          $(this).children('span').text('열기');
      }
  });

  $('.2depth_btn').on('click',function (){
      $(this).toggleClass('active');
      $(this).siblings('ul').stop().slideToggle();
      if($(this).hasClass('active')){
          $(this).children('span').text('닫기');
      }else{
          $(this).children('span').text('열기');
      }
  });


  $(".site_map_btn").on("click",function(){
    var $this = $(this);
    if($this.is(".open") === true){
          if(wWidth > 1300){
              menuClose($this);       
          }else{
              menuCloseMo($this);       
          }
      
    }else{
          if(wWidth > 1300){
        menuOpen($this);
          }else{
            menuOpenMo($this);  
          }
    }
  });

  var $pageChack ,dep1Name, pageName;
  var pageNum = 0;
  var subNum = 0;

  $pageChack = $("#pageingCheck");
  if($pageChack.length > 0){
    pageNum = $pageChack.find(".pageNum").html();
    subNum = $pageChack.find(".subNum").html();
    dep1Name = $pageChack.find(".dep1Name").html();
    pageName = $pageChack.find(".pageName").html();
    $pageChack.css("display","none");
    $(".location > div > ul.lnb > li.dep1 button b").html(dep1Name);
    if(pageNum != "2" && pageNum != "3" && pageNum != "4" && pageNum != "6"){
      $(".location > div > ul.lnb > li.dep2").css("display","inline-block");
      $(".location > div > ul.lnb > li.dep2 button b").html(pageName);
    }

    $("#menu_wrap #dropmenu > li:nth-child("+pageNum+")").addClass("active")
    $("#menu_wrap #dropmenu > li:nth-child("+pageNum+") .depth_2 li.n"+subNum).addClass("active");

    $("div.location > div > ul.lnb > li > ul li.n"+pageNum).addClass("active");
    $("div.location > div > ul.lnb > li:nth-child(3) ul li:nth-child("+subNum+")").addClass("active");
  }
  if($(".btnMove").length > 0){
    $(".btnMove").on("click",function(e){
      e.preventDefault();

      var $this = $(this);
      var $id = $($this.attr("href"));
      var offset = $id.offset();
      var winH = $(window).height();
      var margin = 90;
      $('html, body').stop().animate({scrollTop : (offset.top - margin)}, 400);

    });
  }
  /* from template */

});

// $(window).on('scroll', stickyHeader);
// $(window).on('scroll', stickyFooter);

$(window).on("beforeunload", function() {
	// $(window).scrollTop(0);
});

/* from template */
$(window).on("resize",function(){
    wWidth =  window.innerWidth ? window.innerWidth : jQuery(window).width();
    // var $btn = $(".site_map_btn");
    // if($btn.is(".open") === true){
    //     menuClose($btn); 
    // }
    $("#menu_wrap #dropmenu > li > a.on").trigger("click");
    $("#menu_wrap #dropmenu > li > ul").css({
        "display":"",
        "height":"",
        "padding":"",
        "margin:":""
    });
});
/* from template */

$(window).on("load", function() {
	$("body").on("submit", "form", function(ev) {
		// setButtonLoading($(this));
	});

	if ($(".is-invalid").length) {
		$("html, body").animate(
			{
				scrollTop:
					$(".is-invalid")
						.first()
						.offset().top - 100,
			},
			1000
		);
	} else if ($(".alert.alert-danger").length) {
		$("html, body").animate(
			{
				scrollTop:
					$(".alert.alert-danger")
						.first()
						.offset().top - 100,
			},
			1000
		);
	}

	$("#searchModal").on("shown.bs.modal", function() {
		$("#keyword").trigger("focus");
	});

	// $(".modal").on("show.bs.modal", function() {
	// 	bodyScrollLock.disableBodyScroll($(this)[0]);
	// });

	// $(".modal").on("hide.bs.modal", function() {
	// 	bodyScrollLock.enableBodyScroll($(this)[0]);
	// });
});

/* from template */
function menuOpen($this){
  var $header = $("#header_wrap");
  $header.addClass("open");
  $this.addClass("open");

};

function menuOpenMo($this){
    var $header = $("#header_wrap");
    $header.addClass("open");
    $this.addClass("open");

    $('#menu_wrap #dropmenu > li > a').off('click').on('click', menuMoSwitch);
};

function menuClose($this){
  var $header = $("#header_wrap");
  $header.removeClass("open");
  $this.removeClass("open");
    $('#menu_wrap #dropmenu > li > a').off('click');
};

function menuCloseMo($this){
    var $header = $("#header_wrap");
    $header.removeClass("open");
    $this.removeClass("open");
    $('#menu_wrap #dropmenu > li > a').off('click');

}

function menuMoSwitch(e){
  var idx = $('#menu_wrap #dropmenu > li > a').index(this);
  
  if($(this).hasClass("solo")){
      return ;
  }
  // console.log(menu_array[idx]);
  // if($(this).parent().index() == 4 || $(this).parent().index() == 5 ){
  //     return true;
  // }else {
      
      $('ul.depth_2').stop().slideUp().siblings('a');
      if(menu_array[idx] == 0){
          for(i=0; i<$('ul.all_menu li').length; i++) {
              menu_array[i] = 0; //0은 닫힌상태, 1은 열린상태
          }
          $('#menu_wrap #dropmenu > li > a').removeClass('on').siblings('ul.depth_2');
          $(this).addClass('on').siblings('ul.depth_2').stop().slideDown();
          menu_array[idx] = 1;
      } else {
          $('#menu_wrap #dropmenu > li > a').removeClass('on').siblings('ul.depth_2').stop().slideUp();
          menu_array[idx] = 0;
      }
  //}

  e.preventDefault();
}
/* from template */

function initOpenAndCloseMainSidebarMenu() {
  $('#burgerCollapse').click(function() {
    if($('#burgerCollapse').hasClass('active')){
      $('#burgerCollapse').removeClass('active');
      $('#header').removeClass('active');
      $('#burgerCollapse').find('i').removeClass('fa-times');
      $('#burgerCollapse').find('i').addClass('fa-bars');
      $('.search').show();
    }else{
      $('#burgerCollapse').addClass('active');
      $('#header').addClass('active');
      $('#burgerCollapse').find('i').addClass('fa-times');
      $('#burgerCollapse').find('i').removeClass('fa-bars');
      $('.search').hide();
    }
  });
}

function initHomeBanner() {
	if ($("#banner").length) {
		var homeBanner = new Swiper("#banner", {
			autoplay: {
				delay: 5000,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			// pagination: {
			// 	el: ".swiper-pagination",
			// 	type: "bullets",
			// },
		});
	}
}

function initInnerBanner() {
	if ($("#innerBanner").length) {
		var innerBanner = new Swiper("#innerBanner", {
			autoplay: {
				delay: 5000,
			},
		});
	}
}

function initHomepageSecondContentSlide() {
  if ($("#secondContentSlideContainer").length) {
    var homeBanner = new Swiper("#secondContentSlideContainer", {
      // autoplay: {
      //   delay: 5000,
      // },
      slidesPerView: 3,
      spaceBetween: 15,
      // loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      breakpoints: {
        480: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        720: {
          slidesPerView: 1,
          spaceBetween: 40
        },
      }
    });
  }  
}

function initInnerPageNavigationSlide() {
  if ($("#innerPageNavigationSlide").length) {
    var slideInnerNav = new Swiper("#innerPageNavigationSlide", {
      slidesPerView: 4,
      spaceBetween: 15,
      autoplay: true,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      breakpoints: {
        480: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        720: {
          slidesPerView: 3,
          spaceBetween: 40
        },
      }
    });
  }  
}

function initPageMilestone() {
  var swiper = new Swiper('.milestone-container', {
    slidesPerView: 3,
    spaceBetween: 0,
    freeMode: true,
    navigation: {
      nextEl: '.milestone-container .swiper-button-next',
      prevEl: '.milestone-container .swiper-button-prev'
    },
    breakpoints: {
      425: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      },
      // 1200: {
      //   slidesPerView: 4
      // }
    }
  });
}

function stickyHeader() {
	if ($(window).scrollTop() > $("#header").innerHeight()) {
		// $("#header").addClass("sticky");
    if($("#header").hasClass('active')){
      $('#burgerCollapse').removeClass('active');
      $("#header").removeClass("active");
      $('#burgerCollapse').find('i').removeClass('fa-times');
      $('#burgerCollapse').find('i').addClass('fa-bars');
    }
		$("#logo").addClass("sticky");
		$("#navigation").addClass("sticky");
    // $(".footer-bottom").addClass("sticky");
	} else {
		$("#header").removeClass("sticky");
		$("#logo").removeClass("sticky");
		$("#navigation").removeClass("sticky");
    // $(".footer-bottom").removeClass("sticky");
	}
}

function stickyFooter() {
  /* check whether it reach the end of header element div */
  if($(window).scrollTop() > $('#header').innerHeight() / 3){
    $(".footer-bottom").addClass("sticky");
  }else{
    $(".footer-bottom").removeClass("sticky");
  }

  /* check whether it reach the end of page element div */
  if($(window).scrollTop() > $('#content').innerHeight() - $(window).height()) {
    $(".footer-bottom").addClass("end-page-class");
  }else{
    $(".footer-bottom").removeClass("end-page-class");
  }
}

function initMobileMenu() {
	var mmenu = new MmenuLight($("#mobileMenu").get(0), {
		title: "Menu",
		selected: "active",
	});

	mmenu.enable("(max-width: 991px)");
	mmenu.offcanvas({
		position: "right",
		move: true,
		blockPage: true,
	});

	$("#mobileMenu").addClass("mm");

	$('a[href="#mobileMenu"]').on("click", function(ev) {
		mmenu.open();

		ev.preventDefault();
		ev.stopPropagation();
	});
}

function initAdsSlider() {
	if ($("#ads").length) {
		var adsSwiper = new Swiper("#ads.swiper-container", {
			autoplay: {
				delay: 5000,
			},
		});
	}
}

function imgToBG(bgClass, imageClass) {
	if (bgClass.length > 0) {
		bgClass.each(function() {
			var img = $(this).find(imageClass).eq(0);

			$(this).css({
				"background-image": 'url("' + img.attr("src") + '")',
			});

			img.hide();
		});
	}
}

function isValidEmailAddress(emailAddress) {
	var pattern = new RegExp(
		/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
	);

	return pattern.test(emailAddress);
}

function initContactFormListener() {
	$("#contactForm").submit(function(ev) {
		var email = $(this).find("input[type='email']").val();

		if (!isValidEmailAddress(email)) {
			ev.preventDefault();
			alert("Invalid email address.");

			return;
		}

		if (!$(this).find(".g-recaptcha").val()) {
			ev.preventDefault();
			$(this).find(".invalid-g-recaptcha").show();

			return;
		}
	});
}

function setButtonLoading($this) {
	var submitButton = $this.find('button[type="submit"]').not(".no-loading");

	if (submitButton.length) {
		submitButton.prop("disabled", true).html('<i class="fas fa-spinner-third fa-spin"></i>');
	}
}

function initNewsletterListener() {
	$("#newsletter").submit(function(ev) {
		ev.preventDefault();

    $("#newsletterModal").modal("show");

	});

	$("#newsletterForm").on("submit", function(ev) {
    if ($('#InterestedNote').val() == '') {
      alert("Message cannot empty!");
    }

    var email = $("#newsletterForm .email-field").val();

    if (!isValidEmailAddress(email)) {
      ev.preventDefault();
      alert("Invalid email address.");
    }

		if (
			!$(this)
				.find(".g-recaptcha")
				.val()
		) {
			ev.preventDefault();

			$(this)
				.find(".invalid-g-recaptcha")
				.show();

			return;
		}

		setButtonLoading($(this));
	});

	$("#newsletterModal").on("shown.bs.modal", function() {
		reSizeCaptcha("#newsletterModal ");

		var message = $("#newsletter .interested-note").val();

		$("#newsletterName").trigger("focus");
		$("#InterestedNote").val(message);
	});

	$("#newsletterModal").on("hide.bs.modal", function() {
		$("#newsletterName").val("");
		$("#newsletterEmail").val("");

		grecaptcha.reset();
	});
}

function reSizeCaptcha(parent = "") {
	if ($(parent + ".g-recaptcha").length) {
		var width = $(parent + ".g-recaptcha")
			.parent()
			.width();

		if (width > 150 && width < 302) {
			var scale = (width - 5) / 302;

			$(parent + ".g-recaptcha").css("transform", "scale(" + scale + ")");
			$(parent + ".g-recaptcha").css("-webkit-transform", "scale(" + scale + ")");
		} else {
			$(parent + ".g-recaptcha").css("transform", "unset");
			$(parent + ".g-recaptcha").css("-webkit-transform", "unset");
		}
	}
}

window.captchaCallback = function(response) {
	$(".g-recaptcha").val(response);
};
